import Const from 'constants';

const defaultState = {
    show: false,
    loading: false,
};

export default function (state = defaultState, action) {
    if (action.type === Const.SHOW_DROPZONE) {
        state = {...state, show: true};
    } else if (action.type === Const.HIDE_DROPZONE) {
        state = {...state, show: false};
    } else if (action.type === Const.DROPZONE_IS_LOADING) {
        state = {...state, loading: true};
    } else if (action.type === Const.DROPZONE_IS_NOT_LOADING) {
        state = {...state, loading: false};
    }

    return state;
}
